<template>
    <div class="today-alarm" >
        <div class="toptitle dn-title-bg" >相位图</div>
        <div class="bottomcontent dn-content-bg" v-loading="ifLoad">
            <div style="margin-bottom:12px" id="topBox" >
                <div>
                    <div class="littletitle littletitle-color">
                        <div  class="curk">
                            <span  class="powerSpan"></span>
                            电压
                        </div>
                        <div class="curk">
                            <span  class="el-icon-right orange1"></span>
                            A相电压
                        </div>
                        <div class="curk">
                            <span class="el-icon-right green1"></span>
                            B相电压
                        </div>
                        <div class="curk">
                            <span  class="el-icon-right red1"></span>
                            C相电压
                        </div>
                    </div>
                    <div class="littletitle littletitle-color">
                        <div class="curk">
                            <span class="powerSpan"></span>
                            电流
                        </div>
                        <div class="curk">
                            <span class="el-icon-right orange1"></span>
                            A相电流
                        </div>
                        <div class="curk">
                            <span class="el-icon-right green1"></span>
                            B相电流
                        </div>
                        <div class="curk">
                            <span class="el-icon-right red1"></span>
                            C相电流
                        </div>
                    </div>
                </div>
                <div class="canvas-box canvas-bg"></div>
                <arc-canvas :width="width" ref="canvas" ></arc-canvas>
            </div>
            <div class="table-warp dn-content-bg">
                <el-table :data="phaseData"
                        style="border-radius: 4px"
                        height="242"
                        :stripe="true"
                        >
                    <template v-for="(item,index) in columns" >
                        <el-table-column :key="index" :prop="item.prop" :label="item.label"  :align="item.align?item.align:'center'" :show-overflow-tooltip="item.showTool?item.showTool:false"></el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
import ArcCanvas from '@/components/page/power/ArcCanvas.vue'
export default {
  props: {
    phaseData: {
      type: Array,
      default: () =>[]
    },
    ifLoad:{
        type:Boolean,
        default:false,
    }
  },
  components: {
    ArcCanvas
  },
  data() {
    return {
        loading: false,
        echarts: null,
        echartsId: uuidv1(),
        interTime:null,
        width: 210,
        columns:[
            { prop: "phase", label: "数据类型", show:true, align: "left",showTool:true },
            { prop: "Aphase", label: "A相", show:true, align: "left",showTool:true },
            { prop: "Bphase", label: "B相", show:true, align: "left",showTool:true },
            { prop: "Cphase", label: "C相", show:true, align: "left",showTool:true }
        ]
    }
  },
  created() {
      
  },
  methods: {
    //调接口拿取数据
    getData() {
        let vm = this
        vm.$nextTick(() => {
            // this.width=Number(document.getElementById('topBox').offsetHeight)-60
            // this.width=209
            vm.$refs['canvas'].draw(vm.phaseData[1].Aphase, vm.phaseData[0].Aphase, 'orange') //A相电压  第一个参数是相角 第二个是有效值
            vm.$refs['canvas'].draw(vm.phaseData[1].Bphase, vm.phaseData[0].Bphase, 'orange') //B相电压
            vm.$refs['canvas'].draw(vm.phaseData[1].Cphase, vm.phaseData[0].Cphase, 'green') //C相电压
            vm.$refs['canvas'].draw(vm.phaseData[3].Aphase, vm.phaseData[2].Aphase, 'green') //A相电流
            vm.$refs['canvas'].draw(vm.phaseData[3].Bphase, vm.phaseData[2].Bphase, 'red') //B相电流 orange
            vm.$refs['canvas'].draw(vm.phaseData[3].Cphase, vm.phaseData[2].Cphase, 'red') //C相电流
            // vm.$refs['canvas'].draw(vm.phaseData[1].Aphase, vm.phaseData[0].Aphase, 'red') //A相电压  第一个参数是相角 第二个是有效值
            // vm.$refs['canvas'].draw(vm.phaseData[1].Bphase, vm.phaseData[0].Bphase, 'red') //B相电压
            // vm.$refs['canvas'].draw(vm.phaseData[1].Cphase, vm.phaseData[0].Cphase, 'green') //C相电压
            // vm.$refs['canvas'].draw(vm.phaseData[3].Aphase, vm.phaseData[2].Aphase, 'green') //A相电流
            // vm.$refs['canvas'].draw(vm.phaseData[3].Bphase, vm.phaseData[2].Bphase, 'orange') //B相电流 orange
            // vm.$refs['canvas'].draw(vm.phaseData[3].Cphase, vm.phaseData[2].Cphase, 'orange') //C相电流
        });
      
    },
    //改表头颜色
    bottomtableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f3f4;color: #666;'
      }
    },
    tableRowClassNameTwo({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'el-table__row--striped"'
      } else if (rowIndex === 3) {
        return 'el-table__row--striped"'
      }
    },
  },
  watch: {
    phaseData: {
      handler(newVal, oldVal) {
        let vm = this
        vm.getData()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    width:100%;
    height: 100%;
}
.toptitle {
    color: #fff;
    font-weight: bold;
    display: flex;
    padding: 5px;
    font-size: 16px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}
.bottomcontent {
    overflow: auto;
    height: calc(100% - 33px);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.littletitle {
    display: flex;
    justify-content: left;
    padding-top: 10px;
    padding-left: 10px;
    box-sizing: border-box;
}
.canvas-box{
    display: flex;
    height: 3px;
    width:100%;
    margin: 12px 0 0 0;
    // background: rgb(211, 218, 220);
}
.powerSpan{
    background:#0692f1;
    height:12px;
    width:12px;
    display: inline-block;
    margin-right: 5px
}
.red1{
    color:red;
}
.green1{
    color:green;
}
.orange1{
    color:orange;
}
.curk{
    margin-left:8px;
}
</style>